import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { selectIsUserSE } from 'src/app/state/selectors/customer-account.selector';

@Component({
  selector: '[my-bill-odb-sub-total]',
  templateUrl: './odb-sub-total.component.html',
  standalone: false,
})
export class OdbSubTotalComponent {
  @Input() amount: string;
  @Input() showVatText = false;
  readonly selectIsUserSE$ = this.store.select(selectIsUserSE);

  constructor(private store: Store<ApplicationState>) {}
}
